import { time } from '@/shared/datetime/utils/time'

import type { CaptureTask } from './types'

/**
 * The bounds a capture stops at, whichever it reaches first — the backend's
 * `CAPTURE_DURATION_SECONDS` and `CAPTURE_MAX_EVENTS` (API quickstart §6.1).
 * Neither is a caller choice; they are restated here only for the copy the
 * panel shows before there is a task to read them off.
 */
export const CAPTURE_WINDOW_SECONDS = 60
export const CAPTURE_MAX_EVENTS = 100

/**
 * How often a waiting capture task is read back.
 *
 * The ask rides down on the collector's next heartbeat and the answer comes
 * back off-beat, so the whole wait is up to about two minutes; a poll this
 * much shorter than the beat shows the answer within seconds of it landing.
 */
const CAPTURE_POLL_INTERVAL = time(5, 's')

/**
 * `refetchInterval` for a capture task: poll while it is waiting, stop at any
 * final state. An expired task is final here even though a late result could
 * still land behind it — the panel shows the API’s summary and offers a new capture instead.
 */
export function captureTaskPollInterval(task: CaptureTask | undefined) {
	return task?.outcome === 'waiting' ? CAPTURE_POLL_INTERVAL : false
}
